export interface IExternalLink {
  name: string;
  link: string;
}

export const homeLink: IExternalLink = {
  name: 'LiliApp-Homepage',
  link: 'https://theliliapp.com',
};

export const socialProjectsImageSrc: IExternalLink = {
  name: 'social-project-logo',
  link:
    'https://theliliapp.com/wp-content/uploads/2020/01/Logo-Proyecto-Social.jpg',
};

export const socialProjectsLink: IExternalLink = {
  name: 'social_projects',
  link: 'https://theliliapp.com/proyecto-social/',
};

export const policyLink: IExternalLink = {
  name: 'policy',
  link: 'https://theliliapp.com/terminos-y-condiciones-registro/',
};

export const helpLink: IExternalLink = {
  name: 'help',
  link: 'https://theliliapp.com/quick-start/',
};

export const footerLinks: IExternalLink[] = [
  {
    name: 'legal_policy',
    link: 'https://theliliapp.com/aviso-legal/',
  },
  {
    name: 'service_conditions',
    link: 'https://theliliapp.com/condiciones-del-servicio/',
  },
  {
    name: 'cookies_policy',
    link: 'https://theliliapp.com/politica-de-cookies/',
  },
  {
    name: 'privacy_policy',
    link: 'https://theliliapp.com/politica-de-privacidad/',
  },
  {
    name: 'FAQ',
    link: 'https://theliliapp.com/faq/',
  },
  {
    name: 'contact',
    link: 'https://theliliapp.com/contacto/',
  },
  helpLink,
];
